import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { toggleChat } from 'apps/auth/actions/chatAction';
import { setNewForm, changeFormFieldValue, removeFieldError } from 'apps/auth/actions/formAction';
import { getField } from 'apps/auth/components/form-multi/utils';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { EMAIL_SCREEN, SELECT_PERIOD_SCREEN, STATEMENT_LIST_SCREEN, STATEMENT_SUCCESS_SCREEN } from 'apps/auth/constants/Constants';
import { EMAIL, END_DATE_CAMELCASE, START_DATE_CAMELCASE } from 'apps/auth/constants/fieldsName';
import { TRANSFER_STATEMENT } from 'apps/auth/constants/formName';
import { REGEXP_EMAIL } from 'apps/auth/constants/RegExps';
import { DEFAULT_DATE_REGEX, USA_DATE_REGEX } from 'apps/auth/constants/utilsMasks';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import { useAuth, useExtra, useFields, usePageMessages } from 'apps/auth/hooks/selectors';
import { useDynamicHeightButton } from 'apps/auth/hooks/useDynamicHeightButton';

import EmailScreen from './EmailScreen';
import SelectPeriodScreen from './SelectPeriodScreen';
import StatementListScreen from './StatementListScreen';
import StatementSuccessScreen from './StatementSuccessScreen';

const TransferStatement = (props) => {
    const [screen, setScreen] = useState(STATEMENT_LIST_SCREEN);
    const [isCustomPeriod, setIsCustomPeriod] = useState(false);
    const { countryId } = useAuth();
    const { startDate, endDate, email } = usePageMessages();
    const { profile_form } = useExtra();
    const formName = TRANSFER_STATEMENT;
    const fields = useFields(formName);
    const dateRegexp = countryId === USA ? USA_DATE_REGEX : DEFAULT_DATE_REGEX;
    const buttonPosition = useDynamicHeightButton(true);

    useEffect(() => {
        let fields = {};
        fields[START_DATE_CAMELCASE] = getField(START_DATE_CAMELCASE, '', dateRegexp, true, false, startDate, 'date');
        fields[END_DATE_CAMELCASE] = getField(END_DATE_CAMELCASE, '', dateRegexp, true, false, endDate, 'date');
        fields[EMAIL] = getField(EMAIL, profile_form?.email || '', REGEXP_EMAIL, true, false, email, 'email');
        props.setNewForm(formName, fields);
    }, []);

    const switchToNextScreen = (nextScreen) => {
        setScreen(nextScreen);
    };

    const onBackIconClick = (e) => {
        e.preventDefault();
        if (screen === EMAIL_SCREEN) {
            if (isCustomPeriod) {
                setScreen(SELECT_PERIOD_SCREEN);
            } else {
                setScreen(STATEMENT_LIST_SCREEN);
                props.changeFormFieldValue(TRANSFER_STATEMENT, '', START_DATE_CAMELCASE);
                props.changeFormFieldValue(TRANSFER_STATEMENT, '', END_DATE_CAMELCASE);
            }
        } else if (screen === SELECT_PERIOD_SCREEN) {
            removeFieldErrors();
            setScreen(STATEMENT_LIST_SCREEN);
        } else if (screen === STATEMENT_LIST_SCREEN) {
            props.modalRef.current.close();
        }
    };

    const removeFieldErrors = () => {
        Object.values(fields)?.forEach((f) => {
            if (f.isError) {
                props.removeFieldError(formName, f.name);
            }
        });
    };

    const renderComponent = () => {
        if (screen === STATEMENT_LIST_SCREEN) {
            return <StatementListScreen switchToNextScreen={switchToNextScreen} setIsCustomPeriod={setIsCustomPeriod} />;
        } else if (screen === SELECT_PERIOD_SCREEN) {
            return (
                <SelectPeriodScreen switchToNextScreen={switchToNextScreen} fields={fields} usaDateFormat={countryId === USA} buttonPosition={buttonPosition} />
            );
        } else if (screen === EMAIL_SCREEN) {
            return (
                <EmailScreen switchToNextScreen={switchToNextScreen} modalRef={props.modalRef} toggleChat={props.toggleChat} buttonPosition={buttonPosition} />
            );
        } else if (screen === STATEMENT_SUCCESS_SCREEN) {
            return <StatementSuccessScreen userEmail={fields?.email?.value} />;
        }
    };
    return (
        <ModalComponent
            canCloseModal={screen === STATEMENT_LIST_SCREEN || screen === SELECT_PERIOD_SCREEN || screen === EMAIL_SCREEN}
            onCloseIconClick={onBackIconClick}
        >
            {renderComponent()}
        </ModalComponent>
    );
};

TransferStatement.propTypes = {
    modalRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { setNewForm, changeFormFieldValue, removeFieldError, toggleChat })(TransferStatement);
